export const ITALIAN_MERGE_SAMPLES = {
  genre: 'Madame',
  noms: 'Yameogo Ernestine',
  birthVerb: 'Nata',
  lieuNaissance: 'Burkina Faso',
  dateNaissance: '30 Juillet 1984',
  dureeCours: '3 mois',
  lieuEmission: 'troia',
  dateEmission: '07 Juillet 2026',
};

export const ITALIAN_MERGE_SAMPLES_IT = {
  genre: '',
  noms: 'Yameogo Ernestine',
  birthVerb: 'Nata',
  lieuNaissance: 'Burkina Faso',
  dateNaissance: '30 luglio 1984',
  dureeCours: 'tre mesi',
  lieuEmission: 'Troia',
  dateEmission: '7 luglio 2026',
};

export const ITALIAN_MERGE_FIELDS = [
  { key: 'genre', label: 'Genre (Madame/Monsieur)' },
  { key: 'noms', label: 'Nom complet' },
  { key: 'lieuNaissance', label: 'Lieu de naissance' },
  { key: 'dateNaissance', label: 'Date de naissance' },
  { key: 'dureeCours', label: 'Durée du cours' },
  { key: 'lieuEmission', label: "Lieu d'émission" },
  { key: 'dateEmission', label: "Date d'émission" },
];

const MERGE_TOKEN_RE = /\{\{(\w+)\}\}/g;

export const formatDateFrench = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const months = [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
  ];
  const day = String(date.getDate()).padStart(2, '0');
  return `${day} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

export const formatDateItalian = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const months = [
    'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
    'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre',
  ];
  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

const capitalize = (value) => {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const formatDureeItalian = (value) => {
  const normalized = (value || '').trim().toLowerCase();
  if (normalized === '3 mois') return 'tre mesi';
  if (normalized === '6 mois') return 'sei mesi';
  if (normalized === '1 mois') return 'un mese';
  return value || '';
};

export const createItalianMergeFieldElement = (key, previewMode = true, editorLocale = 'fr') => {
  const span = document.createElement('span');
  span.className = 'cierha-merge-field';
  span.contentEditable = 'false';
  span.dataset.var = key;
  const field = ITALIAN_MERGE_FIELDS.find((f) => f.key === key);
  const label = field?.label || key;
  const samples = editorLocale === 'it' ? ITALIAN_MERGE_SAMPLES_IT : ITALIAN_MERGE_SAMPLES;
  span.textContent = previewMode
    ? (samples[key] || label)
    : `{{${key}}}`;
  span.title = `Champ: ${label}`;
  return span;
};

export const italianTextToEditableHtml = (text, previewMode = true, allowMergeFields = true, editorLocale = 'fr') => {
  if (!text) return '';
  if (!allowMergeFields) {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  const parts = text.split(MERGE_TOKEN_RE);
  const frag = document.createDocumentFragment();

  parts.forEach((part, index) => {
    if (index % 2 === 0) {
      if (part) frag.appendChild(document.createTextNode(part));
    } else if (ITALIAN_MERGE_FIELDS.some((f) => f.key === part) || part === 'birthVerb') {
      frag.appendChild(createItalianMergeFieldElement(part, previewMode, editorLocale));
    } else {
      frag.appendChild(document.createTextNode(`{{${part}}}`));
    }
  });

  const container = document.createElement('div');
  container.appendChild(frag);
  return container.innerHTML;
};

export { serializeEditable, applyMergeTemplate } from './mergeFieldUtils';

export const insertItalianMergeFieldAtCursor = (fieldKey) => {
  const selection = window.getSelection();
  if (!selection?.rangeCount) return false;

  const range = selection.getRangeAt(0);
  range.deleteContents();
  const field = createItalianMergeFieldElement(fieldKey, true);
  const space = document.createTextNode('\u00A0');
  range.insertNode(space);
  range.insertNode(field);
  range.setStartAfter(space);
  range.collapse(true);
  selection.removeAllRanges();
  selection.addRange(range);
  return true;
};

export const buildItalianMergeData = (docData, locale = 'fr') => {
  const isItalian = locale === 'it';
  const genre = docData.genre === 'Homme' ? 'Monsieur' : 'Madame';
  const birthVerb = docData.genre === 'Homme' ? 'Nato' : 'Nata';

  return {
    genre: isItalian ? '' : genre,
    birthVerb,
    noms: docData.noms || '',
    lieuNaissance: docData.lieuNaissance || '',
    dateNaissance: isItalian
      ? formatDateItalian(docData.dateNaissance)
      : formatDateFrench(docData.dateNaissance),
    dureeCours: isItalian
      ? formatDureeItalian(docData.dureeCours)
      : (docData.dureeCours || ''),
    lieuEmission: isItalian
      ? capitalize(docData.lieuEmission)
      : (docData.lieuEmission || ''),
    dateEmission: isItalian
      ? formatDateItalian(docData.dateEmission)
      : formatDateFrench(docData.dateEmission),
  };
};
